import axios from 'axios';
import _get from 'lodash/get';
import { generateId } from '../../../utils/trainUtils';
import { SERVER_URL } from '../../../constants/ClientConfig';
import {
    FETCH_AVAILABILITY,
    SEARCH_TRAINS,
    SET_SEARCH_DATA,
    APPLY_FILTER,
    SORT_SELECTED,
    ACTION_SET_CONFIRM_OPTIONS,
    ACTION_INIT_RAILS_LISTING_FILTERS,
    ACTION_CLEAR_ALL_FILTERS_ON_LISTING_PAGE,
    FETCH_AVAILABILITY_SET_LOADER,
    FETCH_AVAILABILITY_SET_ERROR,
    FETCH_AVAILABILITY_REMOVE_ERROR,
    CONFIRMATION_PROBABILITY,
    DEFAULT_SORT_SELECTED,
    CONFIRMED_OPTIONS_AS_ALTERNATE_AVAILABILITY,
    SET_BIZ_USER_INFO,
    MYBIZ_REQUISITION_FLOW,
} from './ListingActionTypes';

import { trackListingEvent } from '../../../utils/railsAnalytics';
import { AVAILABILITY_UPDATED_MESSAGE, MMT_AUTH, MORE_THAN_ONE_DAY_KEY, MY_BIZ_TRAVELERS, MY_BUSINESS_SUBSCRIPTION, PAGES } from '../../../constants/TrainConstants';
import { getCookie, filterUnavailableClasses } from '../../../utils/trainUtils';
import { getTrainType } from '../../../constants/TrainConstants';
import { getClassType, availability, AcClasses } from '../../../constants/Classes';
import { DEFAULT_SORT } from '../../../constants/SortFields';
import PDTInfo from '../../../utils/pdtInfo';
import { searchConnector } from '../components/RailModifySearch/searchConnector';
import { getDeviceId } from '../../../utils/readCookie';
import { getBookingForDataFromStorage, getMyBizHeaders, isBussinessUser, isUserLoggedIn, setBookingForDataInStorage } from '../../../utils/BizUtils';
import { getUserInfoPIIClient } from 'pwa-mmt-ui-header/getPIIData/client';
import isEmpty from 'lodash/isEmpty';
import { fetchPaxDetailsFromRequisitionId } from '../../../API/MyBiz/MyBizApis';
import {
    setItemBySession,
    itemType
  } from "MMT-UI/storages/client/sessionStorage";

export const getStationInfoFromLocus = async (data) => {
    const traceId = generateId();
    return new Promise((resolve, reject) => {
        const headers = {"X-Trace-Id": traceId};
        const locusUrl = `${SERVER_URL}/getInfoFromLocus`;
        axios.post(locusUrl, data,{ headers }).then((res) => {
            if (res.data.error) {
                reject(res.data.error)
            }
            resolve(res.data.data)
        })
            .catch((err) => {
                reject(err)
            })
    })
}
export const getB2bUserInfo = () => async (dispatch) => {
    try {
        const isB2b = isBussinessUser();
        const isLoggedIn = isUserLoggedIn();
        const userInfo = isLoggedIn ? await getUserInfoPIIClient() : {};
        const { firstName = '', email = '', lastName = '', mobileNumber  = '' } = userInfo;
        let bookingForData = getBookingForDataFromStorage()?.[0] || {};
        if (isB2b) {
            let data = {
                name: bookingForData?.name || `${firstName || ''} ${lastName || ''}`.trim(),
                email: bookingForData?.email || email,
                mobile: bookingForData?.mobile || mobileNumber,
            };
            dispatch(setBookingForData(data));
            if(isEmpty(bookingForData)){
                setBookingForDataInStorage(data);
            }
        }
      } catch (error) {
        console.error('Error in fetching User Details: ', error);
      }
}

export const getB2bUserInfoFromRequisitionId = requisitionId => async dispatch => {
    try {
        const isLoggedIn = isUserLoggedIn();
        if(!isLoggedIn){
            return;
        }
        dispatch({
            type: MYBIZ_REQUISITION_FLOW,
            payload: { isRequisitionFlow: true, myBizRequisitionLoading: true, errorMessage: null },
        });
        const requisitionIdData = await fetchPaxDetailsFromRequisitionId(
            requisitionId
        );    
        let bookingForData = requisitionIdData?.travelInfo?.paxDetails?.find((traveler) => traveler.isPrimaryPax || traveler.primaryPax);
        if(!bookingForData?.email){
            const traceId = generateId();
            dispatch({
                type: MYBIZ_REQUISITION_FLOW,
                payload: { myBizRequisitionLoading: false, errorMessage: `Error while getting traveler information. Please contact your admin - ${traceId}` },
            });
            return;
        }
        const data = {
            name: bookingForData?.name,
            email: bookingForData?.email,
            mobile: bookingForData?.phoneNumber,
        };
        dispatch(setBookingForData(data));
        setBookingForDataInStorage(data);
        setItemBySession(
            MY_BIZ_TRAVELERS,
            requisitionIdData?.travelInfo?.paxDetails,
            { isPiiData: true, shouldStringifyJson: true },
            itemType.ES
          );
        dispatch({
            type: MYBIZ_REQUISITION_FLOW,
            payload: { myBizRequisitionLoading: false, errorMessage: null },
        });
    } catch (error) {
      console.error("Error in fetching User Details: ", error);
    }
  };

export const setBookingForData = (data) => async (dispatch) => {
    dispatch({
        type: SET_BIZ_USER_INFO,
        data: data
    });
}

export const searchTrainsAction = (searchData) => async (dispatch, getState) => {
    const traceId = generateId();
    const mmtAuth = getCookie(MMT_AUTH);
    const myBusinessSubscription = getCookie(MY_BUSINESS_SUBSCRIPTION) || 'b2c';
    let combinedErrorMessage = '';
    let res ='';
    try {
        const { srcStn, srcCity, destStn, destCity, date, classCode, className, requisitionId } = searchData;
        
        const alternateAvailabilityParams = {
            source: srcStn,
            destination: destStn,
            doj: date
        }

        const fromStationNode = {
            code: srcStn,
            city: srcCity,
        };

        const toStationNode = {
            code: destStn,
            city: destCity,
        };

        const classNode = {
            code: classCode,
            name: className,
        };

        dispatch({
            type: SET_SEARCH_DATA,
            data: {
                fromStationNode,
                toStationNode,
                classNode,
                doj: date,
                requisitionId: myBusinessSubscription === 'b2b' ? requisitionId : null,
            },
        });
        const pdtLanding = `${SERVER_URL}/postPdtData`
        const pdtTrackingBody = {
            eventType : "LANDING",
            data: {
                departureDate: date.split('-').join(''),
                frmStnCode: srcStn,
                frmStnName: srcCity,
                toStnCode: destStn,
                toStnName: destCity,
                quota: "",
                journeyClass: classCode,
                ...PDTInfo()
            }
        }
        let headers = {
            ...await getMyBizHeaders(PAGES.LISTING, requisitionId),
            "mmt-auth": getCookie(MMT_AUTH),
            "X-Trace-Id": traceId,
        }
        axios.post(pdtLanding,pdtTrackingBody,{headers});
        const url = `${SERVER_URL}/trains`;
        const body = { srcStn, destStn, date, mmtAuth, myBusinessSubscription };
        res = await axios.post(url, body, {headers});   
        if (res.data.errorDetails) {
            const { errorMessage, errorCode } = res.data.errorDetails;
            combinedErrorMessage = errorCode ? `${errorMessage} Error Code:${errorCode}.${traceId}` : errorMessage;
            const railSearchData = { errorMessage: combinedErrorMessage };
            dispatch({
                type: SEARCH_TRAINS,
                payload: { railSearchData },
            });
        } else if (res.data.trainBtwnStnsList.length === 0) {
            const railSearchData = { errorMessage: 'No Trains Found. Error Code: Rails_No_BE.' + traceId};
            dispatch({
                type: SEARCH_TRAINS,
                payload: { railSearchData },
            });
        } else {
            const railSearchData = res.data.trainBtwnStnsList;
            const updatedRailSearchData = railSearchData.map((train) => {
                const preferred = train.tbsAvailability.filter((avl) => avl.className === classCode);
                const nonPreferred = train.tbsAvailability.filter((avl) => avl.className !== classCode);
                const loaderAdded_tbsAvailability = [...preferred, ...nonPreferred].map((el) => ({ ...el, showLoader: false }))
                return (
                    {
                        ...train,
                        tbsAvailability: loaderAdded_tbsAvailability,
                    }
                );
            });
            const { quotaList } = res.data;
            dispatch({
                type: SEARCH_TRAINS,
                payload: { railSearchData: updatedRailSearchData, quotaList, fromStationNode, toStationNode },
            });

            dispatch(getConfirmOptions(fromStationNode, toStationNode, date, requisitionId));
            dispatch(getAlternateAvailibility(alternateAvailabilityParams, requisitionId));

            const newFilterObject = initializeFilters(updatedRailSearchData, fromStationNode, toStationNode)
            dispatch(defaultSort(DEFAULT_SORT));
            dispatch({
                type: ACTION_INIT_RAILS_LISTING_FILTERS,
                data: { filterObject: newFilterObject },
            });
            dispatch(getConfirmationProbability({  railSearchData,searchData }));
        }
        searchConnector({
            fromDateTime: date,
            fromCity: srcStn,
            fromCityName: srcCity,
            toCity: destStn,
            toCityName: destCity,
        });
    } catch (error) {
        const railSearchData = res?.data?.errorDetails ? { errorMessage: combinedErrorMessage } :
        { errorMessage: `No Trains Found. Error Code:Rails_No_BE.${traceId}` };
        dispatch({
            type: SEARCH_TRAINS,
            payload: { railSearchData },
        });
    }
};

const getConfirmationProbability = ({  railSearchData ,searchData}) => async (dispatch, getState) => {
    const traceId = generateId();
    try {
        const state = getState();
        const railsConfirmationGuaranteeOption = _get(state, "abConfig.railsConfirmationGuaranteeOption", 1);
        const zcEnable = _get(state, "abConfig.free_cancellation_rails", true);
        const confirmationProbabilityUrl = "https://rails.makemytrip.com/pwa/mobile/enquiry/confirmationProbability";
        let deviceid = 'rails-dweb';
        try {
            deviceid = document.cookie.split(';').filter(biscuit => biscuit.includes('dvid'))[0].split('=')[1];
        } catch (err) {
            console.log('device id not found');
        }
        let mmtAuth = null; // mmt-auth
        try {
            mmtAuth = getCookie('mmt-auth');
        } catch (err) {
            console.log('auth not found');
        }
        const pdtdata = PDTInfo();
        const { srcStn, srcCity, destStn, destCity, date, classCode, requisitionId } = searchData;
        const reqBody = {
            departureDate: date,
            frmStnCode:srcStn,
            toStnCode:destStn,
            frmStnName:srcCity,
            toStnName:destCity,
            journeyClass:classCode,
            quota:"",
            railsConfirmationGuaranteeOption,
            zcEnable,
            trainBtwnStnsList: railSearchData,
            ...pdtdata
        };
        const headers = {
            ...await getMyBizHeaders(PAGES.LISTING, requisitionId),
            deviceid,
            'mmt-auth':mmtAuth,
            "X-Trace-Id": traceId
        };
        const res = await axios.post(confirmationProbabilityUrl, reqBody, { headers });
        const { confirmationGuaranteeWidget, trainBtwnStnsList, railofyPokus } = res.data;
        const updatedTicketTypeFilter = initialiseTicketFilter(trainBtwnStnsList)
        dispatch({
            type: CONFIRMATION_PROBABILITY,
            payload: {
                confirmationGuaranteeWidget,
                trainBtwnStnsList,
                railofyPokus,
                updatedTicketTypeFilter
            },
        });
    } catch (error) {
        console.log('error inside', error);
        dispatch({
            type: CONFIRMATION_PROBABILITY,
            payload: {
                confirmationProbabilityData: null
            },
        });
    }
}

export const getConfirmOptions = (from, to, date, requisitionId) => async (dispatch) => {
    const traceId = generateId();
    try {
        const myBizHeaders = await getMyBizHeaders(PAGES.LISTING, requisitionId);
        const headers = {...myBizHeaders,"X-Trace-Id": traceId};
        const res = await axios.post(`${SERVER_URL}/confirmOptions`, {
            source: from.code,
            destination: to.code,
            doj: date,
        }, { headers });

        const data = res;
        if (res.status === 200 && !res.data?.error) {
            dispatch({
                type: ACTION_SET_CONFIRM_OPTIONS,
                data,
            });
        } else {
            dispatch({
                type: ACTION_SET_CONFIRM_OPTIONS,
                data: null,
            });
        }
    } catch (e) {
        console.log(e);
        dispatch({
            type: ACTION_SET_CONFIRM_OPTIONS,
            data: null,
        });
    }
};

export const checkAvailability = async (reqBody, reqHeaders = {}) => {
    const traceId = generateId();
    const headers = {
        ...reqHeaders,
        "mmt-device-id": getDeviceId(),
        "X-Trace-Id": traceId
    }
    if (
        typeof reqBody.skipNearbyCheck !== "undefined"
        && reqBody.skipNearbyCheck
    ) {
        return await axios.post(`${SERVER_URL}/availability/fetchLatestAvailability`, reqBody, {headers})
    }
    return await axios.post(`${SERVER_URL}/availability/nearByDate`, reqBody, { headers })
}

export const checkAvailabilityAction = (body) => async (dispatch, getState) => {
    trackListingEvent('check_availability_clicked');
    const state = getState();
    const railsConfirmationGuaranteeOption = _get(state, 'abConfig.railsConfirmationGuaranteeOption', 1);
    const zcEnable = _get(state, 'abConfig.free_cancellation_rails', true)
    const { trainNumber, class: className, quota } = body;
    const key = `${trainNumber}_${className}_${quota}`;
    try {
        dispatch({
            type: FETCH_AVAILABILITY_SET_LOADER,
            payload: { trainNumber, className, quota },
        });
        const reqBody = {
            ...body,
            railsConfirmationGuaranteeOption: railsConfirmationGuaranteeOption,
            zcEnable: zcEnable,
        };

        if(!reqBody.hasOwnProperty(MORE_THAN_ONE_DAY_KEY)) {
            Object.assign(reqBody, {moreThanOneDay: true});
        }

        const requisitionId = _get(state, 'listing.requisitionId', true)
        const reqHeaders = await getMyBizHeaders(PAGES.LISTING, requisitionId);
        const res = await checkAvailability(reqBody, reqHeaders);
        const availabilityResponse = res.data;
        const { totalFare, errorMessage } = availabilityResponse;
        if (errorMessage) {
            dispatch({
                type: FETCH_AVAILABILITY_SET_ERROR,
                payload: { availabilityResponse,  trainNumber, className, quota, errorMessage },
            });
            setTimeout(() => {
                dispatch({
                  type: FETCH_AVAILABILITY_REMOVE_ERROR,
                  payload: { trainNumber, className, quota },
                });
              }, 7000);
        } else {
            const [availability] = availabilityResponse.avlDayList;
            const { reason, ...restKeys } = availability; // check type definition for restKeys
            const tbsAvailability = {
                ...restKeys,
                className,
                quota,
                lastUpdatedOn: AVAILABILITY_UPDATED_MESSAGE,
                totalFare,
            };
            dispatch({
                type: FETCH_AVAILABILITY,
                payload: { availabilityResponse, tbsAvailability, trainNumber, className, quota, selectedKey: key },
            });
        }
        return availabilityResponse;
    } catch (error) {
        console.error(error);
    }
};

export const getAlternateAvailibility = (body, requisitionId) => async (dispatch) => {
    const traceId= generateId();
    try {
        const { source, destination, doj } = body;
        const myBizHeaders = await getMyBizHeaders(PAGES.LISTING, requisitionId);
        const headers = {...myBizHeaders,"X-Trace-Id": traceId};
        let res = await axios.post(`${SERVER_URL}/alternateAvailability`, { source, destination, doj }, { headers });
        const data= res?.data;
        if(res?.status === 200 && !res?.data?.error){
            dispatch({
                type: CONFIRMED_OPTIONS_AS_ALTERNATE_AVAILABILITY,
                data
            })
        } else {
            dispatch({
                type: CONFIRMED_OPTIONS_AS_ALTERNATE_AVAILABILITY,
                data: null
            })
        }
    } catch (e) {
        console.log('error in fetching Alternate Availibilty', e);
        dispatch({
            type: CONFIRMED_OPTIONS_AS_ALTERNATE_AVAILABILITY,
            data: null
        })
    }
};

export const onApplyFilterClick = (filter, filters) => async dispatch => {
    dispatch({
        type: APPLY_FILTER,
        payload: { filter, filters }
    })
}

export const onClearAllFiltersClickedInListing = () => ({
    type: ACTION_CLEAR_ALL_FILTERS_ON_LISTING_PAGE,
});

export const viewRoutesAction = (trn, ssc, doj) => async (dispatch) => {
    const traceId = generateId();
    try {
        const headers = {"X-Trace-Id": traceId};
        const res = await axios.get(`${SERVER_URL}/route/${trn}/${ssc}/${doj}`,{ headers });
        const railRouteData = res.data.stationList;
        return railRouteData
    } catch (error) {
        console.error(error);
    }
};

export const sortAction = (sortField) => (dispatch, getState) => {
    trackListingEvent(`sort_${sortField.toLowerCase().replace(/\s/gi, '_')}_clicked`);
    const { listing: { selectedSortField, isAscOrder } } = getState();
    const newOrder = (selectedSortField === sortField) ? !isAscOrder : true;
    dispatch({
        type: SORT_SELECTED,
        payload: {
            selectedSortField: sortField,
            isAscOrder: newOrder,
        },
    });
};

export const defaultSort = (payload) => (dispatch) =>{
    console.log('defaultSort',payload)
    dispatch({
        type: DEFAULT_SORT_SELECTED,
        payload
    });
}

const initializeFilters = (trains, from, to) => {

    const quickFilter = {
        heading: "Quick Filters",
        filterTypes: {
            AC: {
                "key": "AC",
                "heading": "AC",
                "filterList": [],
                "parentFilterType": "journeyClassFilter",
                "selected": false,
                "id": "quickFilter"
            },
            "available": {
                "key": "available",
                "heading": "Available",
                "filterList": [
                    "1",
                    "2"
                ],
                "parentFilterType": "availabilityFilter",
                "selected": false,
                "id": "quickFilter"
            },
            "departureAfter6": {
                "key": "departureAfter6",
                "heading": "Departure after 6 PM",
                "filterList": [
                    "eveningFilter"
                ],
                "parentFilterType": "departureTimeFilter",
                "selected": false,
                "id": "quickFilter"
            },
            "arrivalBefore12": {
                "key": "arrivalBefore12",
                "heading": "Arrival before 12 PM",
                "filterList": [
                    "nightFilter",
                    "morningFilter"
                ],
                "parentFilterType": "arrivalTimeFilter",
                "selected": false,
                "id": "quickFilter"
            }
        },
        "id": "quickFilter",
        "filterTypesList": [
            "AC",
            "available",
            "departureAfter6",
            "arrivalBefore12"
        ]
    }
    const journeyClassFilter = { id: 'journeyClassFilter', heading: 'Journey Class Filters', filterTypes: {}, filterTypesList: [] }
    const arrivalTimeFilter = {
        heading: `Arrival in ${to.city}`,
        id: "arrivalTimeFilter",
        filterTypes: {
            nightFilter: { key: "night", heading: "Night", subHeading: "12 AM to 6 AM", selected: false, noOfTrains: 0 },
            morningFilter: { key: "morning", heading: "Morning", subHeading: "6 AM to 12 PM", selected: false, noOfTrains: 0 },
            afternoonFilter: { key: "afternoon", heading: "Afternoon", subHeading: "12 PM to 6 PM", selected: false, noOfTrains: 0 },
            eveningFilter: { key: "evening", heading: "Evening", subHeading: "6PM to 12 AM", selected: false, noOfTrains: 0 }
        },
        filterTypesList: ["nightFilter", "morningFilter", "afternoonFilter", "eveningFilter"]
    }
    const departureTimeFilter = {
        id: "departureTimeFilter",
        heading: `Departure from ${from.city}`,
        filterTypes: {
            nightFilter: { key: "night", heading: "Night", subHeading: "12 AM to 6 AM", selected: false, noOfTrains: 0 },
            morningFilter: { key: "morning", heading: "Morning", subHeading: "6 AM to 12 PM", selected: false, noOfTrains: 0 },
            afternoonFilter: { key: "afternoon", heading: "Afternoon", subHeading: "12 PM to 6 PM", selected: false, noOfTrains: 0 },
            eveningFilter: { key: "evening", heading: "Evening", subHeading: "6PM to 12 AM", selected: false, noOfTrains: 0 }
        },
        filterTypesList: ["nightFilter", "morningFilter", "afternoonFilter", "eveningFilter"]
    }
    const trainTypeFilter = { heading: "Train Types", id: "trainTypeFilter", filterTypes: {}, filterTypesList: [] }
    const startStationsFilter = { id: "startStationsFilter", heading: `Stations in ${from.city}`, filterTypes: {}, filterTypesList: [] }
    const endStationsFilter = { id: "endStationsFilter", heading: `Stations in ${to.city}`, filterTypes: {}, filterTypesList: [] }
   
    trains.map((train) => {
        journeyClassFilterScan(train, journeyClassFilter)
        trainTypeFilterScan(train, trainTypeFilter)
        arrivalDepartureFilterScan(train, [arrivalTimeFilter, departureTimeFilter])
        stationsFilter(train, [startStationsFilter, endStationsFilter])
    });
    let ACClasses = journeyClassFilter.filterTypesList.filter((el) => AcClasses[el] == 'AC')
    quickFilter.filterTypes.AC.filterList = ACClasses
    const ticketTypeFilter = initialiseTicketFilter([])
    return {
        quickFilter,
        ticketTypeFilter,
        journeyClassFilter,
        arrivalTimeFilter,
        departureTimeFilter,
        trainTypeFilter,
        startStationsFilter,
        endStationsFilter,
    }
}

const journeyClassFilterScan = (train, classFilter) => {
    const { avlClasses } = train;
    avlClasses.map((el) => {
        if (classFilter.filterTypesList.includes(el)) {
            classFilter.filterTypes[el].noOfTrains += 1
        }
        else {

            classFilter.filterTypesList.push(el)
            classFilter.filterTypes[el] = {}
            classFilter.filterTypes[el].noOfTrains = 1
            classFilter.filterTypes[el].selected = false
            classFilter.filterTypes[el].key = el
            classFilter.filterTypes[el].subHeading = el
            classFilter.filterTypes[el].heading = getClassType(el).value
        }
    })
}

const arrivalDepartureFilterScan = (train, filterType) => {

    const { arrivalTime12hFormat, arrivalMeridiem, departureMeridiem, departureTime12hFormat } = train;

    const data = [
        [0, 600, "nightFilter"],
        [600, 1200, "morningFilter"],
        [1200, 1800, "afternoonFilter"],
        [1800, 2400, "eveningFilter"]
    ]
    let arrivalFullTime = arrivalTime12hFormat.split(':')
    let arrivalHour = Number(arrivalFullTime[0])
    let arrivalTime = Number(arrivalFullTime[0] + arrivalFullTime[1])
    if (arrivalMeridiem == 'PM' && arrivalHour !== 12) {
        arrivalTime = arrivalHour + 12
    }
    else if(arrivalHour == 12 ){
        arrivalTime = arrivalHour - 12
    }
    else {
        arrivalTime = arrivalHour
    }
    // arrivalTime = arrivalMeridiem == 'PM' && arrivalHour !== 12 ? arrivalHour + 12 : arrivalHour
    arrivalTime += arrivalFullTime[1]

    let hr = Number(arrivalTime)
    for (let i = 0; i < data.length; i++) {
        if (hr >= data[i][0] && hr < data[i][1]) {
            filterType[0].filterTypes[data[i][2]].noOfTrains += 1
            break;
        }
    }

    let departureFullTime = departureTime12hFormat.split(':')
    let departureHour = Number(departureFullTime[0])
    let departureTime = Number(departureFullTime[0] + departureFullTime[1])
    if (departureMeridiem == 'PM' && departureHour !== 12) {
        departureTime = departureHour + 12
    }
    else if(departureHour == 12 && departureMeridiem == 'AM'){
        departureTime = departureHour - 12
    }
    else {
        departureTime = departureHour
    }

    departureTime += departureFullTime[1]

    let dhr = Number(departureTime)
    for (let j = 0; j < data.length; j++) {
        if (dhr >= data[j][0] && dhr < data[j][1]) {
            filterType[1].filterTypes[data[j][2]].noOfTrains += 1
            break;
        }
    }
}

const trainTypeFilterScan = (train, trainFilter) => {
    const { trainType } = train;
    trainType.forEach((el) => {
        if (trainFilter.filterTypesList.includes(el)) {
            trainFilter.filterTypes[el].noOfTrains += 1
        }
        else {
            trainFilter.filterTypesList.push(el)
            trainFilter.filterTypes[el] = {}
            trainFilter.filterTypes[el].noOfTrains = 1
            trainFilter.filterTypes[el].selected = false
            trainFilter.filterTypes[el].key = el
            trainFilter.filterTypes[el].subHeading = el
            trainFilter.filterTypes[el].heading = getTrainType(el);
        }
    })
}

const stationsFilter = (train, filterType) => {
    const { toStnCode, frmStnCode, frmStnName, toStnName } = train;
    const arr = [frmStnCode, toStnCode]
    arr.forEach((el, i) => {
        if (filterType[i].filterTypesList.includes(el)) {
            filterType[i].filterTypes[el].noOfTrains += 1
        }
        else {
            filterType[i].filterTypesList.push(el)
            filterType[i].filterTypes[el] = {}
            filterType[i].filterTypes[el].noOfTrains = 1
            filterType[i].filterTypes[el].selected = false
            filterType[i].filterTypes[el].key = el
            filterType[i].filterTypes[el].subHeading = el
            filterType[i].filterTypes[el].heading = i == 1 ? toStnName : frmStnName
        }
    })
}

const initialiseTicketFilter =(trainsList)=>{
    const ticketTypeFilter = { 
        heading: "Ticket Types", 
        id: "ticketTypeFilter", 
        filterTypes: {
                freeCancellation: { key: "freeCancellation", heading: "Free Cancellation", subHeading: "", selected: false, noOfTrains: 0 },
                tripGurantee: { key: "tripGurantee", heading: "Trip Guarantee", subHeading: "", selected: false, noOfTrains: 0 },
        }, 
        filterTypesList: ["freeCancellation","tripGurantee"] 
    }
    trainsList.map((train) => {
        let isFreeCancellationPreset = train.tbsAvailability.filter((el)=>el.freeCancellationText!==null)
        if(isFreeCancellationPreset.length>0){
            ticketTypeFilter.filterTypes.freeCancellation.noOfTrains+=1
        }
        let isTripGuranteePreset = train.tbsAvailability.filter((el)=>el.confirmationGuaranteeText!==null)
        if(isTripGuranteePreset.length>0){
            ticketTypeFilter.filterTypes.tripGurantee.noOfTrains+=1
        }
    });
    return ticketTypeFilter
}